import { InlineText2 } from '@cian/ui-kit';
import * as React from 'react';

export const LeadPosition = () => {
  return <InlineText2 color="current_color">Вы на 1 месте</InlineText2>;
};
